import { e as __awaiter, f as __generator } from '../../../_tslib-7a01aab4.js';
import { k as httpClient, Z as loadingStore } from '../../../environmentBuilder-3507f66e.js';
import '../store/chatStore.js';
import '../store/wageringStore.js';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../store/gameResultStore.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../store/forCrashGame/inputValidationStore.js';
import '../store/forCrashGame/totalBetStore.js';
import '../store/forCrashGame/resultReportStore.js';
import '../store/forCrashGame/gameStore.js';
import { rtlCheckerAndSetter } from './rtlCheckerAndSetter.js';
import { parseQuery } from './parseQuery.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import { ApiServiceTypes } from '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import { DefaultQueryParams } from '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import '../services/liveConnection/types.js';
import 'axios';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import { ApiServices } from '../services/ApiServices.js';
import 'mobx';
import '../classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../enums/BogLineGameConfig.js';
import '../enums/StatisticsSortingTypes.js';
import '../services/api/BaseApiService.js';
import './deepCopy.js';
import '../polyfill.js';
import '../../../_commonjsHelpers-17aad09c.js';
import '../../../momentFormat-e9197995.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './isMobile.js';
import '../enums/bogGameNames.js';
import './updateHalfBets.js';
import 'howler';

var getFileByName = function (fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, httpClient.get("".concat(process.env.PUBLIC_URL, "/").concat(fileName))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_1 = _a.sent();
                console.error('Error fetching JSON from public folder:', error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
var MAX_RETRIES = 3;
var RETRY_DELAY = 5000;
var getTranslationsWithRetry = function (setTranslations, setLanguage, appDefaultValuesEnum, isNeedRtlChecker, retries, delay) {
    if (retries === void 0) { retries = MAX_RETRIES; }
    if (delay === void 0) { delay = RETRY_DELAY; }
    return __awaiter(void 0, void 0, void 0, function () {
        var query, lang, partnerId, response, result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = parseQuery(window.location.search);
                    lang = query[DefaultQueryParams.Culture] || appDefaultValuesEnum.LANGUAGE;
                    partnerId = query[DefaultQueryParams.PartnerId];
                    if (isNeedRtlChecker) {
                        rtlCheckerAndSetter(lang);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiServices.get(ApiServiceTypes.TranslationService).getTranslations({
                            applicationId: appDefaultValuesEnum.APPLICATION_ID,
                            code: lang,
                            partnerId: partnerId,
                        })];
                case 2:
                    response = _a.sent();
                    result = response.data.result;
                    if (result && Object.keys(result).length) {
                        setTranslations(result);
                    }
                    loadingStore.updateLoading({ isTranslationsLoaded: true });
                    setLanguage(lang);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error fetching translations:', error_2);
                    if (!loadingStore.isTranslationsLoaded) {
                        setLanguage(appDefaultValuesEnum.LANGUAGE);
                        loadingStore.updateLoading({ isTranslationsLoaded: true });
                    }
                    if (retries > 0) {
                        setTimeout(function () {
                            return getTranslationsWithRetry(setTranslations, setLanguage, appDefaultValuesEnum, isNeedRtlChecker, retries - 1, delay * 5);
                        }, delay);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};

export { getFileByName, getTranslationsWithRetry };
